// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '../outgoing-payment/types';

export function bolivianOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'bo',
    document: userInputValues['bolivianDocument'],
    document_type: userInputValues['bolivianDocumentType'],
    zipcode: userInputValues['bolivianZipcode'],
    state: userInputValues['bolivianState'],
    city: userInputValues['bolivianCity'],
    address: userInputValues['bolivianAddress'],
    street_number: userInputValues['bolivianStreetNumber'],
    street_complement: userInputValues['bolivianStreetComplement'],
    phone_number: userInputValues['bolivianPhoneNumber'],
  };
}
